var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSyncFailed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 636 486",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4801_103593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M636 428.529H0V428.847H636V428.529Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.476 371.784H55.853C51.8462 371.784 48.5898 368.527 48.5898 364.519V19.1738C48.5898 15.166 51.8462 11.9089 55.853 11.9089H301.476C305.483 11.9089 308.739 15.166 308.739 19.1738V364.519C308.739 368.527 305.483 371.784 301.476 371.784ZM55.853 12.2397C52.0242 12.2397 48.9078 15.3569 48.9078 19.1865V364.532C48.9078 368.361 52.0242 371.479 55.853 371.479H301.476C305.305 371.479 308.421 368.361 308.421 364.532V19.1738C308.421 15.3441 305.305 12.227 301.476 12.227H55.853V12.2397Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.611 371.784H330.988C326.981 371.784 323.725 368.527 323.725 364.519V19.1738C323.725 15.166 326.981 11.9089 330.988 11.9089H576.611C580.618 11.9089 583.874 15.166 583.874 19.1738V364.519C583.874 368.527 580.618 371.784 576.611 371.784ZM330.988 12.2397C327.159 12.2397 324.043 15.3569 324.043 19.1865V364.532C324.043 368.361 327.159 371.479 330.988 371.479H576.611C580.44 371.479 583.556 368.361 583.556 364.532V19.1738C583.556 15.3441 580.44 12.227 576.611 12.227H330.988V12.2397Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.271 449.014H539.199V449.332H572.271V449.014Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.87 452.462H395.592V452.78H452.87V452.462Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.928 437.194H460.604V437.512H537.928V437.194Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1891 439.331H66.7285V439.649H91.1891V439.331Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.852 439.331H102.523V439.649H172.852V439.331Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.546 444.701H215.82V445.019H310.546V444.701Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.899 136.596H102.523V428.529H231.899V136.596Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.738 146.851H114.658V418.287H219.738V146.851Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.525 159.574H121.895V165.783H212.525V159.574Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.525 173.671H121.895V179.88H212.525V173.671Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.525 187.781H121.895V193.99H212.525V187.781Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.525 201.879H121.895V208.088H212.525V201.879Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.525 215.989H121.895V222.198H212.525V215.989Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.525 230.099H121.895V236.308H212.525V230.099Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.525 244.196H121.895V250.405H212.525V244.196Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.525 258.306H121.895V264.515H212.525V258.306Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.525 272.403H121.895V278.612H212.525V272.403Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.525 286.513H121.895V292.722H212.525V286.513Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.525 300.623H121.895V306.832H212.525V300.623Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.525 314.721H121.895V320.929H212.525V314.721Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.525 328.831H121.895V335.039H212.525V328.831Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.525 342.928H121.895V349.137H212.525V342.928Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.525 357.038H121.895V363.247H212.525V357.038Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.525 371.148H121.895V377.357H212.525V371.148Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.525 385.245H121.895V391.454H212.525V385.245Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.525 399.355H121.895V405.564H212.525V399.355Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7294 428.529H102.523L102.523 136.596H66.7294L66.7294 428.529Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.115 131.57H112.584V136.596H214.115V131.57Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4982 136.596H112.584V131.57H84.4982V136.596Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0984 158.073C98.241 158.073 99.9779 153.835 99.9779 148.607C99.9779 143.379 98.241 139.141 96.0984 139.141C93.9557 139.141 92.2188 143.379 92.2188 148.607C92.2188 153.835 93.9557 158.073 96.0984 158.073Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 148.607C68 153.836 69.1702 158.073 70.6203 158.073C72.0704 158.073 73.2406 153.836 73.2406 148.607C73.2406 143.378 72.0704 139.141 70.6203 139.141C69.1702 139.141 68 143.378 68 148.607Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0984 425.985C98.241 425.985 99.9779 421.747 99.9779 416.519C99.9779 411.291 98.241 407.053 96.0984 407.053C93.9557 407.053 92.2188 411.291 92.2188 416.519C92.2188 421.747 93.9557 425.985 96.0984 425.985Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 416.519C68 421.748 69.1702 425.985 70.6203 425.985C72.0704 425.985 73.2406 421.748 73.2406 416.519C73.2406 411.289 72.0704 407.053 70.6203 407.053C69.1702 407.053 68 411.289 68 416.519Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.752 201.713H372.238V428.529H472.752V201.713Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.312 209.678H381.662V420.577H463.312V209.678Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.703 219.564H387.285V224.386H457.703V219.564Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.703 230.519H387.285V235.341H457.703V230.519Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.703 241.473H387.285V246.295H457.703V241.473Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.703 252.441H387.285V257.263H457.703V252.441Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.703 263.395H387.285V268.217H457.703V263.395Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.703 274.35H387.285V279.172H457.703V274.35Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.703 285.317H387.285V290.139H457.703V285.317Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.703 296.272H387.285V301.094H457.703V296.272Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.703 307.227H387.285V312.049H457.703V307.227Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.703 318.194H387.285V323.016H457.703V318.194Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.703 329.149H387.285V333.971H457.703V329.149Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.703 340.103H387.285V344.925H457.703V340.103Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.703 351.071H387.285V355.893H457.703V351.071Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.703 362.025H387.285V366.847H457.703V362.025Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.703 372.98H387.285V377.802H457.703V372.98Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.703 383.947H387.285V388.769H457.703V383.947Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.703 394.902H387.285V399.724H457.703V394.902Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.703 405.857H387.285V410.679H457.703V405.857Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.432 428.529H372.238V201.713H344.432V428.529Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.95 197.807H380.061V201.713H458.95V197.807Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.219 201.713H380.047V197.807H358.219V201.713Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.236 211.052C364.236 215.111 365.585 218.406 367.251 218.406C368.917 218.406 370.266 215.111 370.266 211.052C370.266 206.993 368.917 203.698 367.251 203.698C365.585 203.698 364.236 206.993 364.236 211.052Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.41 211.052C345.41 215.111 346.326 218.406 347.445 218.406C348.565 218.406 349.481 215.111 349.481 211.052C349.481 206.993 348.565 203.698 347.445 203.698C346.326 203.698 345.41 206.993 345.41 211.052Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.236 419.191C364.236 423.249 365.585 426.545 367.251 426.545C368.917 426.545 370.266 423.249 370.266 419.191C370.266 415.132 368.917 411.837 367.251 411.837C365.585 411.837 364.236 415.132 364.236 419.191Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.41 419.191C345.41 423.249 346.326 426.545 347.445 426.545C348.565 426.545 349.481 423.249 349.481 419.191C349.481 415.132 348.565 411.837 347.445 411.837C346.326 411.837 345.41 415.132 345.41 419.191Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.238 211.688H307.925C299.746 211.688 293.106 205.034 293.106 196.866V176.878C293.106 169.396 287.026 163.327 279.547 163.327H231.885V162.055H279.547C287.726 162.055 294.378 168.709 294.378 176.878V196.866C294.378 204.347 300.458 210.416 307.925 210.416H367.238V211.688Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.446 419.839H329.498C321.319 419.839 314.667 413.185 314.667 405.004V288.549C314.667 281.068 308.586 274.999 301.12 274.999H231.885V273.726H301.12C309.299 273.726 315.939 280.381 315.939 288.549V405.004C315.939 412.485 322.019 418.567 329.498 418.567H347.446V419.839Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.045 67.5982H481.896V74.4687H549.045V67.5982Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.313 74.456H481.896V67.5855H463.313V74.456Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.045 50.7655H481.896V57.636H549.045V50.7655Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.313 57.636H481.896V50.7655H463.313V57.636Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.045 33.9327H481.896V40.8033H549.045V33.9327Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.313 40.816H481.896V33.9455H463.313V40.816Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.045 17.1H481.896V23.9705H549.045V17.1Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.313 23.9832L481.896 23.9832V17.1127L463.313 17.1127V23.9832Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M542.355 0H485.688V67.5983H542.355V0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.004 67.5983H485.688V1.52588e-05H470.004V67.5983Z",
    fill: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M375.721 179.333H326.686V184.346H375.721V179.333Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.126 184.359H326.686V179.346H313.126V184.359Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.721 167.043H326.686V172.056H375.721V167.043Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.126 172.068H326.686V167.055H313.126V172.068Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.721 154.765H326.686V159.778H375.721V154.765Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.126 159.778H326.686V154.765H313.126V159.778Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.721 142.474H326.686V147.487H375.721V142.474Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.126 147.487H326.686V142.474H313.126V147.487Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.837 129.98H329.459V179.333H370.837V129.98Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.011 179.333H329.459V129.98H318.011V179.333Z",
    fill: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M601.375 338.386H538.182V344.849H601.375V338.386Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.704 344.862H538.182V338.398H520.704V344.862Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.375 322.545H538.182V329.009H601.375V322.545Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.704 329.021H538.182V322.558H520.704V329.021Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.375 306.718H538.182V313.181H601.375V306.718Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.704 313.181H538.182V306.718H520.704V313.181Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.375 290.877H538.182V297.341H601.375V290.877Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.704 297.341H538.182V290.877H520.704V297.341Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M595.079 274.782H541.744V338.398H595.079V274.782Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.003 338.386H541.758V274.77H527.003V338.386Z",
    fill: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M317.999 485.987C454.208 485.987 564.627 479.539 564.627 471.585C564.627 463.63 454.208 457.182 317.999 457.182C181.79 457.182 71.3711 463.63 71.3711 471.585C71.3711 479.539 181.79 485.987 317.999 485.987Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.614 88.6678H405.105V221.549H543.614V88.6678Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M543.614 88.6678H405.105V221.549H543.614V88.6678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M543.601 88.6678H449.193V221.549H543.601V88.6678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.882 95.4493H453.912V111.9H538.882V95.4493Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.882 116.023H453.912V132.474H538.882V116.023Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.882 136.596H453.912V153.047H538.882V136.596Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.882 157.169H453.912V173.621H538.882V157.169Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.882 177.743H453.912V194.194H538.882V177.743Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.882 198.316H453.912V214.767H538.882V198.316Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.257 95.4493H410.053V111.9H444.257V95.4493Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.257 116.023H410.053V132.474H444.257V116.023Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.257 136.596H410.053V153.047H444.257V136.596Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.257 157.169H410.053V173.621H444.257V157.169Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.257 177.743H410.053V194.194H444.257V177.743Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.257 198.316H410.053V214.767H444.257V198.316Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M429.262 98.7446H413.209V108.618H429.262V98.7446Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M429.262 119.318H413.209V129.191H429.262V119.318Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M429.262 139.891H413.209V149.765H429.262V139.891Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M429.262 160.465H413.209V170.338H429.262V160.465Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M429.262 181.025H413.209V190.899H429.262V181.025Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M429.262 201.599H413.209V211.472H429.262V201.599Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M534.723 97.5995H532.738V109.763H534.723V97.5995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M530.906 97.5995H528.922V109.763H530.906V97.5995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M527.09 97.5995H525.105V109.763H527.09V97.5995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M523.273 97.5995H521.289V109.763H523.273V97.5995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M519.459 97.5995H517.475V109.763H519.459V97.5995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M534.723 118.173H532.738V130.336H534.723V118.173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M530.906 118.173H528.922V130.336H530.906V118.173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M527.09 118.173H525.105V130.336H527.09V118.173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M523.273 118.173H521.289V130.336H523.273V118.173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M519.459 118.173H517.475V130.336H519.459V118.173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M534.723 138.734H532.738V150.897H534.723V138.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M530.906 138.734H528.922V150.897H530.906V138.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M527.09 138.734H525.105V150.897H527.09V138.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M523.273 138.734H521.289V150.897H523.273V138.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M519.459 138.734H517.475V150.897H519.459V138.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M534.723 159.307H532.738V171.483H534.723V159.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M530.906 159.307H528.922V171.483H530.906V159.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M527.09 159.307H525.105V171.483H527.09V159.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M523.273 159.307H521.289V171.483H523.273V159.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M519.459 159.307H517.475V171.483H519.459V159.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M534.723 179.88H532.738V192.056H534.723V179.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M530.906 179.88H528.922V192.056H530.906V179.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M527.09 179.88H525.105V192.056H527.09V179.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M523.273 179.88H521.289V192.056H523.273V179.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M519.459 179.88H517.475V192.056H519.459V179.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M534.723 200.454H532.738V212.617H534.723V200.454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M530.906 200.454H528.922V212.617H530.906V200.454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M527.09 200.454H525.105V212.617H527.09V200.454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M523.273 200.454H521.289V212.617H523.273V200.454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M519.459 200.454H517.475V212.617H519.459V200.454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M485.191 206.535C485.191 205.416 486.095 204.512 487.214 204.512C488.333 204.512 489.236 205.416 489.236 206.535C489.236 207.655 488.333 208.558 487.214 208.558C486.095 208.558 485.191 207.655 485.191 206.535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M472.471 206.535C472.471 205.416 473.374 204.512 474.493 204.512C475.613 204.512 476.516 205.416 476.516 206.535C476.516 207.655 475.613 208.558 474.493 208.558C473.374 208.558 472.471 207.655 472.471 206.535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M459.75 206.535C459.75 205.416 460.653 204.512 461.772 204.512C462.892 204.512 463.795 205.416 463.795 206.535C463.795 207.655 462.892 208.558 461.772 208.558C460.653 208.558 459.75 207.655 459.75 206.535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M485.191 185.962C485.191 184.842 486.095 183.939 487.214 183.939C488.333 183.939 489.236 184.842 489.236 185.962C489.236 187.082 488.333 187.985 487.214 187.985C486.095 187.985 485.191 187.082 485.191 185.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M472.471 185.962C472.471 184.842 473.374 183.939 474.493 183.939C475.613 183.939 476.516 184.842 476.516 185.962C476.516 187.082 475.613 187.985 474.493 187.985C473.374 187.985 472.471 187.082 472.471 185.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M459.75 185.962C459.75 184.842 460.653 183.939 461.772 183.939C462.892 183.939 463.795 184.842 463.795 185.962C463.795 187.082 462.892 187.985 461.772 187.985C460.653 187.985 459.75 187.082 459.75 185.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M485.191 165.401C485.191 164.282 486.095 163.378 487.214 163.378C488.333 163.378 489.236 164.282 489.236 165.401C489.236 166.521 488.333 167.424 487.214 167.424C486.095 167.424 485.191 166.521 485.191 165.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M472.471 165.401C472.471 164.282 473.374 163.378 474.493 163.378C475.613 163.378 476.516 164.282 476.516 165.401C476.516 166.521 475.613 167.424 474.493 167.424C473.374 167.424 472.471 166.521 472.471 165.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M459.75 165.401C459.75 164.282 460.653 163.378 461.772 163.378C462.892 163.378 463.795 164.282 463.795 165.401C463.795 166.521 462.892 167.424 461.772 167.424C460.653 167.424 459.75 166.521 459.75 165.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M485.191 144.828C485.191 143.708 486.095 142.805 487.214 142.805C488.333 142.805 489.236 143.708 489.236 144.828C489.236 145.948 488.333 146.851 487.214 146.851C486.095 146.851 485.191 145.948 485.191 144.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M472.471 144.828C472.471 143.708 473.374 142.805 474.493 142.805C475.613 142.805 476.516 143.708 476.516 144.828C476.516 145.948 475.613 146.851 474.493 146.851C473.374 146.851 472.471 145.948 472.471 144.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M459.75 144.828C459.75 143.708 460.653 142.805 461.772 142.805C462.892 142.805 463.795 143.708 463.795 144.828C463.795 145.948 462.892 146.851 461.772 146.851C460.653 146.851 459.75 145.948 459.75 144.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M485.191 124.255C485.191 123.135 486.095 122.232 487.214 122.232C488.333 122.232 489.236 123.135 489.236 124.255C489.236 125.374 488.333 126.278 487.214 126.278C486.095 126.278 485.191 125.374 485.191 124.255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M472.471 124.255C472.471 123.135 473.374 122.232 474.493 122.232C475.613 122.232 476.516 123.135 476.516 124.255C476.516 125.374 475.613 126.278 474.493 126.278C473.374 126.278 472.471 125.374 472.471 124.255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M459.75 124.255C459.75 123.135 460.653 122.232 461.772 122.232C462.892 122.232 463.795 123.135 463.795 124.255C463.795 125.374 462.892 126.278 461.772 126.278C460.653 126.278 459.75 125.374 459.75 124.255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M485.191 103.681C485.191 102.562 486.095 101.658 487.214 101.658C488.333 101.658 489.236 102.562 489.236 103.681C489.236 104.801 488.333 105.704 487.214 105.704C486.095 105.704 485.191 104.801 485.191 103.681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M472.471 103.681C472.471 102.562 473.374 101.658 474.493 101.658C475.613 101.658 476.516 102.562 476.516 103.681C476.516 104.801 475.613 105.704 474.493 105.704C473.374 105.704 472.471 104.801 472.471 103.681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M459.75 103.681C459.75 102.562 460.653 101.658 461.772 101.658C462.892 101.658 463.795 102.562 463.795 103.681C463.795 104.801 462.892 105.704 461.772 105.704C460.653 105.704 459.75 104.801 459.75 103.681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.285 338.704H149.777V471.585H288.285V338.704Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M288.285 338.704H149.777V471.585H288.285V338.704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M288.273 338.704H193.865V471.585H288.273V338.704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.554 345.485H198.584V361.936H283.554V345.485Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.554 366.059H198.584V382.51H283.554V366.059Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.554 386.632H198.584V403.083H283.554V386.632Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.554 407.205H198.584V423.656H283.554V407.205Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.554 427.766H198.584V444.217H283.554V427.766Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.554 448.339H198.584V464.79H283.554V448.339Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.929 345.485H154.725V361.936H188.929V345.485Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.929 366.059H154.725V382.51H188.929V366.059Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.929 386.632H154.725V403.083H188.929V386.632Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.929 407.205H154.725V423.656H188.929V407.205Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.929 427.766H154.725V444.217H188.929V427.766Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.929 448.339H154.725V464.79H188.929V448.339Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M173.934 348.78H157.881V358.654H173.934V348.78Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M173.934 369.354H157.881V379.227H173.934V369.354Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M173.934 389.915H157.881V399.788H173.934V389.915Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M173.934 410.488H157.881V420.361H173.934V410.488Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M173.934 431.061H157.881V440.934H173.934V431.061Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M173.934 451.635H157.881V461.508H173.934V451.635Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M279.394 347.635H277.41V359.811H279.394V347.635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M275.578 347.635H273.594V359.811H275.578V347.635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M271.762 347.635H269.777V359.811H271.762V347.635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M267.945 347.635H265.961V359.811H267.945V347.635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M264.131 347.635H262.146V359.811H264.131V347.635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M279.394 368.196H277.41V380.359H279.394V368.196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M275.578 368.196H273.594V380.359H275.578V368.196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M271.762 368.196H269.777V380.359H271.762V368.196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M267.945 368.196H265.961V380.359H267.945V368.196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M264.131 368.196H262.146V380.359H264.131V368.196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M279.394 388.769H277.41V400.933H279.394V388.769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M275.578 388.769H273.594V400.933H275.578V388.769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M271.762 388.769H269.777V400.933H271.762V388.769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M267.945 388.769H265.961V400.933H267.945V388.769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M264.131 388.769H262.146V400.933H264.131V388.769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M279.394 409.343H277.41V421.519H279.394V409.343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M275.578 409.343H273.594V421.519H275.578V409.343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M271.762 409.343H269.777V421.519H271.762V409.343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M267.945 409.343H265.961V421.519H267.945V409.343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M264.131 409.343H262.146V421.519H264.131V409.343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M279.394 429.916H277.41V442.08H279.394V429.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M275.578 429.916H273.594V442.08H275.578V429.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M271.762 429.916H269.777V442.08H271.762V429.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M267.945 429.916H265.961V442.08H267.945V429.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M264.131 429.916H262.146V442.08H264.131V429.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M279.394 450.49H277.41V462.666H279.394V450.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M275.578 450.49H273.594V462.666H275.578V450.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M271.762 450.49H269.777V462.666H271.762V450.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M267.945 450.49H265.961V462.666H267.945V450.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M264.131 450.49H262.146V462.666H264.131V450.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M208.467 353.717C208.467 354.837 207.564 355.74 206.444 355.74C205.325 355.74 204.422 354.837 204.422 353.717C204.422 352.597 205.325 351.694 206.444 351.694C207.564 351.694 208.467 352.597 208.467 353.717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M221.188 353.717C221.188 354.837 220.284 355.74 219.165 355.74C218.046 355.74 217.143 354.837 217.143 353.717C217.143 352.597 218.046 351.694 219.165 351.694C220.284 351.694 221.188 352.597 221.188 353.717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M233.908 353.717C233.908 354.837 233.005 355.74 231.886 355.74C230.766 355.74 229.863 354.837 229.863 353.717C229.863 352.597 230.766 351.694 231.886 351.694C233.005 351.694 233.908 352.597 233.908 353.717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M208.467 374.29C208.467 375.41 207.564 376.313 206.444 376.313C205.325 376.313 204.422 375.41 204.422 374.29C204.422 373.171 205.325 372.267 206.444 372.267C207.564 372.267 208.467 373.171 208.467 374.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M221.188 374.29C221.188 375.41 220.284 376.313 219.165 376.313C218.046 376.313 217.143 375.41 217.143 374.29C217.143 373.171 218.046 372.267 219.165 372.267C220.284 372.267 221.188 373.171 221.188 374.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M233.908 374.29C233.908 375.41 233.005 376.313 231.886 376.313C230.766 376.313 229.863 375.41 229.863 374.29C229.863 373.171 230.766 372.267 231.886 372.267C233.005 372.267 233.908 373.171 233.908 374.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M208.467 394.864C208.467 395.984 207.564 396.887 206.444 396.887C205.325 396.887 204.422 395.984 204.422 394.864C204.422 393.744 205.325 392.841 206.444 392.841C207.564 392.841 208.467 393.744 208.467 394.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M221.188 394.864C221.188 395.984 220.284 396.887 219.165 396.887C218.046 396.887 217.143 395.984 217.143 394.864C217.143 393.744 218.046 392.841 219.165 392.841C220.284 392.841 221.188 393.744 221.188 394.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M233.908 394.864C233.908 395.984 233.005 396.887 231.886 396.887C230.766 396.887 229.863 395.984 229.863 394.864C229.863 393.744 230.766 392.841 231.886 392.841C233.005 392.841 233.908 393.744 233.908 394.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M208.467 415.425C208.467 416.544 207.564 417.448 206.444 417.448C205.325 417.448 204.422 416.544 204.422 415.425C204.422 414.305 205.325 413.402 206.444 413.402C207.564 413.402 208.467 414.305 208.467 415.425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M221.188 415.425C221.188 416.544 220.284 417.448 219.165 417.448C218.046 417.448 217.143 416.544 217.143 415.425C217.143 414.305 218.046 413.402 219.165 413.402C220.284 413.402 221.188 414.305 221.188 415.425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M233.908 415.425C233.908 416.544 233.005 417.448 231.886 417.448C230.766 417.448 229.863 416.544 229.863 415.425C229.863 414.305 230.766 413.402 231.886 413.402C233.005 413.402 233.908 414.305 233.908 415.425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M208.467 435.998C208.467 437.118 207.564 438.021 206.444 438.021C205.325 438.021 204.422 437.118 204.422 435.998C204.422 434.878 205.325 433.975 206.444 433.975C207.564 433.975 208.467 434.878 208.467 435.998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M221.188 435.998C221.188 437.118 220.284 438.021 219.165 438.021C218.046 438.021 217.143 437.118 217.143 435.998C217.143 434.878 218.046 433.975 219.165 433.975C220.284 433.975 221.188 434.878 221.188 435.998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M233.908 435.998C233.908 437.118 233.005 438.021 231.886 438.021C230.766 438.021 229.863 437.118 229.863 435.998C229.863 434.878 230.766 433.975 231.886 433.975C233.005 433.975 233.908 434.878 233.908 435.998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M208.467 456.571C208.467 457.691 207.564 458.594 206.444 458.594C205.325 458.594 204.422 457.691 204.422 456.571C204.422 455.452 205.325 454.548 206.444 454.548C207.564 454.548 208.467 455.452 208.467 456.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M221.188 456.571C221.188 457.691 220.284 458.594 219.165 458.594C218.046 458.594 217.143 457.691 217.143 456.571C217.143 455.452 218.046 454.548 219.165 454.548C220.284 454.548 221.188 455.452 221.188 456.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M233.908 456.571C233.908 457.691 233.005 458.594 231.886 458.594C230.766 458.594 229.863 457.691 229.863 456.571C229.863 455.452 230.766 454.548 231.886 454.548C233.005 454.548 233.908 455.452 233.908 456.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.64 221.549H489.096V338.118H491.64V221.549Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M416.364 406.417H402.117V403.872H416.364V406.417ZM386.853 406.417H371.589V403.872H386.853V406.417ZM356.325 406.417H341.061V403.872H356.325V406.417ZM325.797 406.417H310.533V403.872H325.797V406.417Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.595 333.958L430.24 424.013C429.363 428.326 433.484 431.977 437.669 430.591L524.813 401.467C528.998 400.068 530.092 394.673 526.798 391.747L458.008 330.815C454.714 327.889 449.486 329.645 448.608 333.958H448.595Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.04 416.252L455.49 345.333C455.846 343.577 457.983 342.864 459.319 344.047L513.493 392.027C514.842 393.223 514.384 395.411 512.692 395.984L444.068 418.923C442.363 419.496 440.684 418.007 441.04 416.239V416.252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.542 366.529L460.539 372.522C460.577 372.624 460.615 372.713 460.653 372.802L467.446 387.065C467.993 388.21 469.303 388.769 470.499 388.362L473.157 387.472C474.353 387.077 475.065 385.843 474.811 384.609L471.707 369.112C471.682 369.01 471.656 368.909 471.631 368.807L469.634 362.814C469.201 361.504 467.777 360.791 466.466 361.237L460.132 363.349C458.822 363.781 458.109 365.206 458.555 366.517L458.542 366.529Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.73 394.266C479.518 396.62 478.246 399.177 475.893 399.966C473.54 400.755 470.983 399.482 470.195 397.129C469.406 394.775 470.678 392.217 473.031 391.429C475.384 390.64 477.941 391.912 478.73 394.266Z",
    fill: "#263238"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4801_103593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 636,
    height: 486,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncFailed);
export default __webpack_public_path__ + "static/media/sync-failed.59223f4ae32d42f0be2ff61c87ed27c4.svg";
export { ForwardRef as ReactComponent };